import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { KpiChartsModule } from '@app/components/kpi-charts/kpi-charts.component';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { MarkComponentVisitedModule } from '@app/directives/mark-component-visited.directive';
import { LinkModule } from '@app/directives/link.directive';
import { InfoboxZoneModule } from '@app/components/infobox-zone/infobox-zone.component';
import { FilterByDepartmentModule } from '../../components/filter-by-department/filter-by-department.component';
import { PowerBIModule } from '@app/components/power-bi/power-bi.component';
import { NewsLayoutModule } from '../news-layout/news-layout.component';
import { CompactLayoutModule } from '../compact-layout/compact-layout.component';

@Component({
  selector: 'app-today',
  templateUrl: './today.component.html',
  styleUrls: ['./today.component.scss']
})
export class TodayComponent {

  hideCompactSectionComponent = false;

  hideCompactSection(event) {
    this.hideCompactSectionComponent = event;
  }
}
@NgModule({
  declarations: [TodayComponent],
  exports: [TodayComponent],
  imports: [
    CommonModule,
    LinkModule,
    InfoboxZoneModule,
    HideParentIfEmptyModule,
    MarkComponentVisitedModule,
    FeatureToggleModule,
    KpiChartsModule,
    FilterByDepartmentModule,
    PowerBIModule,
    NewsLayoutModule,
    CompactLayoutModule
  ]
})
export class TodayModule { }
